import { Trophy } from 'lucide-react'

export default function FoundingListerBadge({ profile, size = 'sm' }) {
if (!profile?.founding_lister_number) return null

const number = profile.founding_lister_number
const suburb = profile.founding_lister_suburb || ''
const tooltip = suburb
? `Founding Lister #${number} of ${suburb}`
: `Founding Lister #${number}`

if (size === 'sm') {
return (
<span
title={tooltip}
style={{
display: 'inline-flex',
alignItems: 'center',
gap: 3,
background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
color: '#5C3D00',
padding: '2px 7px',
borderRadius: 99,
fontSize: 11,
fontWeight: 700,
boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
flexShrink: 0,
lineHeight: 1.2,
}}
>
<Trophy size={12} /> #{number}
</span>
)
}

return (
<div
title={tooltip}
className="founding-lister-badge-lg"
style={{
display: 'inline-flex',
alignItems: 'center',
gap: 8,
background: 'linear-gradient(135deg, #FFF8DC 0%, #FFE4B5 100%)',
border: '1px solid #FFD700',
color: '#5C3D00',
padding: '8px 14px',
borderRadius: 99,
fontSize: 13,
fontWeight: 700,
boxShadow: '0 2px 4px rgba(255, 215, 0, 0.25)',
}}
>
<Trophy size={18} />
<span>
Founding Lister #{number}
{suburb && <span style={{ fontWeight: 500, opacity: 0.85 }}> of {suburb}</span>}
</span>
</div>
)
}
